import { Component, inject } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CardModule } from '@primeng/card';
import { ModalService } from '@shared/services/modal/modal.service';
import { Table } from '@primeng/table';
import {
  AddPersonComponent
} from '@modules/universal-billing/properties/property-profile/tabs/object-resposible/add-person/add-person.component';

@Component({
  selector: 'commercial',
  standalone: true,
  imports: [
    CardModule,
    TranslatePipe,
    Table
  ],
  templateUrl: './commercial.component.html',
  styleUrl: './commercial.component.scss'
})
export class CommercialComponent {
  modalService = inject(ModalService);
  translate = inject(TranslateService);

  maintenanceContracts = [
    {
      title: 'Heizungsreparatur',
      status: 'Abgeschlossen',
      date: '2023-10-15T09:00:00Z',
      assigned: 'Heizungsservice Schmidt',
    },
  ];
}
